// Mock data for dropdowns
export const collectionTypeOptions = [
  { name: "Prepaid", value: "prepaid" },
  { name: "Collect", value: "collect" },
  { name: "Third Party", value: "third-party" },
  { name: "Outbound Collect", value: "outbound-collect" },
];

export const accountOptions = [
  { name: "Account 1", value: "account1" },
  { name: "Account 2", value: "account2" },
  { name: "Account 3", value: "account3" },
];

export const locationOptions = [
  { name: "New York, NY", value: "nyc" },
  { name: "Los Angeles, CA", value: "la" },
  { name: "Chicago, IL", value: "chicago" },
  { name: "Houston, TX", value: "houston" },
];

// Pickup Types mock data - matching backend response structure
export const mockPickupTypes = [
  {
    id: 1,
    typeName: "Pickup",
    fieldName: "pickup_type",
  },
  {
    id: 2,
    typeName: "Dock Drop",
    fieldName: "pickup_type",
  },
  {
    id: 3,
    typeName: "Free Astray",
    fieldName: "pickup_type",
  },
];

// Trace Types mock data - matching backend response structure
export const mockTraceTypes = [
  {
    id: 1,
    refTraceType: "PROBILL",
    description: "Probill",
    isActive: true,
  },
  {
    id: 2,
    refTraceType: "PACKING_LIST",
    description: "Packing List",
    isActive: true,
  },
  {
    id: 3,
    refTraceType: "BOL",
    description: "Bill of Lading",
    isActive: true,
  },
  {
    id: 4,
    refTraceType: "PURCHASE_ORDER",
    description: "Purchase Order",
    isActive: true,
  },
  {
    id: 5,
    refTraceType: "REFERENCE_NUMBER",
    description: "Reference Number",
    isActive: true,
  },
  {
    id: 6,
    refTraceType: "INACTIVE_TYPE",
    description: "Inactive Type",
    isActive: false,
  },
];

// Service Levels mock data - matching backend response structure
export const mockServiceLevels = [
  {
    id: 1,
    code: "LTL",
    description: "Standard LTL Freight",
  },
  {
    id: 2,
    code: "LTL-CC",
    description: "LTL Critical Care Freight",
  },
  {
    id: 3,
    code: "LTL-UC",
    description: "LTL Urgent Care Freight",
  },
  {
    id: 4,
    code: "AIR",
    description: "Air Freight",
  },
  {
    id: 5,
    code: "VOLUME",
    description: "Volume Freight",
  },
  {
    id: 6,
    code: "TRUCKLOAD",
    description: "Truckload Freight",
  },
  {
    id: 7,
    code: "PARTNER",
    description: "Partner Freight",
  },
  {
    id: 8,
    code: "PARTNERLTL",
    description: "Partner LTL Freight",
  },
  {
    id: 9,
    code: "PARTNER-CC",
    description: "Partner Critical Care Freight",
  },
  {
    id: 10,
    code: "NON-NTM",
    description: "Non-Network Freight",
  },
  {
    id: 11,
    code: "OCEAN",
    description: "Ocean Freight",
  },
  {
    id: 12,
    code: "OCEAN-PT",
    description: "Ocean Port to Port Freight",
  },
  {
    id: 13,
    code: "MXUS-LTL",
    description: "Mexico-US LTL Freight",
  },
  {
    id: 14,
    code: "POOL",
    description: "Pool Distribution",
  },
];

export const classOptions = [
  { name: "Class 50", value: "50" },
  { name: "Class 55", value: "55" },
  { name: "Class 60", value: "60" },
  { name: "Class 65", value: "65" },
  { name: "Class 70", value: "70" },
  { name: "Class 77.5", value: "77.5" },
  { name: "Class 85", value: "85" },
  { name: "Class 92.5", value: "92.5" },
  { name: "Class 100", value: "100" },
  { name: "Class 110", value: "110" },
  { name: "Class 125", value: "125" },
  { name: "Class 150", value: "150" },
  { name: "Class 175", value: "175" },
  { name: "Class 200", value: "200" },
  { name: "Class 250", value: "250" },
  { name: "Class 300", value: "300" },
  { name: "Class 400", value: "400" },
  { name: "Class 500", value: "500" },
];

export const classValues = [
  "50",
  "55",
  "60",
  "65",
  "70",
  "77.5",
  "85",
  "92.5",
  "100",
  "110",
  "125",
  "150",
  "175",
  "200",
  "250",
  "300",
  "400",
  "500",
];

export const handlingUnitOptions = [
  { name: "CRATES", value: "CRATES" },
  { name: "GAYLORDS", value: "GAYLORDS" },
  { name: "INTERMEDIATE BULK CO", value: "INTERMEDIATE BULK CO" },
  { name: "PALLETS", value: "PALLETS" },
  { name: "TOTES", value: "TOTES" },
];

export const pieceTypeOptions = [
  { name: "PCS - PIECES", value: "PCS - PIECES" },
  { name: "PLS - PAILS", value: "PLS - PAILS" },
  { name: "RLS - REELS", value: "RLS - REELS" },
  { name: "ROL - ROLLS", value: "ROL - ROLLS" },
  { name: "STK - STACKS", value: "STK - STACKS" },
  { name: "TNK - TANKS", value: "TNK - TANKS" },
  { name: "TUB - TUBES", value: "TUB - TUBES" },
  { name: "ZCR - CRATES", value: "ZCR - CRATES" },
  { name: "BDL - BUNDLES", value: "BDL - BUNDLES" },
  { name: "BGS - BAGS", value: "BGS - BAGS" },
  { name: "BLS - BALES", value: "BLS - BALES" },
  { name: "BTS - BOATS", value: "BTS - BOATS" },
  { name: "CGS - CAGES", value: "CGS - CAGES" },
  { name: "CLS - COILS", value: "CLS - COILS" },
  { name: "CTN - CARTONS", value: "CTN - CARTONS" },
  { name: "DRM - DRUMS", value: "DRM - DRUMS" },
  { name: "EA - EACH", value: "EA - EACH" },
  { name: "HRD - HUNDRED", value: "HRD - HUNDRED" },
];

export const specialShipmentTagOptions = [
  "UC - Urgent Care",
  "CC - Critical Care",
  "MXUS-Mexico",
  "OCEN- Ocean",
  "POOL",
  "Truckload",
  "Volume",
];

export const pickupAccessorialOptions = [
  "P-DOCK DROP",
  "P-INSIDE PICKUP REQUIRED",
  "P-LIFT GATE PICKUP REQUIRED",
  "P-GROCERY WAREHOUSE PICKUP",
  "P-DO NOT BREAK STRAPS",
  "P-BOBTAIL/STRAIGHT TRUCK REQUIRED - PICKUP",
  "P-ATTEMPTED PICKUP/DRY RUN",
  "P-AFTER HOURS CHARGE - PICKUP",
  "P-LIMITED ACCESS-CONSTRUCTION SITE-PICKUP",
  "P-LIMITED QUANTITY",
  "P-LOOSE NON-STACKABLE",
  "P-LOOSE STACKABLE",
  "P-OVERSIZED SKID NON-STACKABLE",
  "P-OVERSIZED SKID STACKABLE",
  "P-SORT & SEG - PICKUP",
  "P-STANDARD SKID NON-STACKABLE",
  "P-STANDARD SKID STACKABLE",
  "P-TRUCK NOT USED",
];

export const deliveryAccessorialOptions = [
  "D-AFTER HOURS CHARGE - DELIVERY",
  "D-APPOINTMENT REQUIRED",
  "D-BOBTAIL/STRAIGHT TRUCK REQUIRED - DELIVERY",
  "D-CURBSIDE/DOCK DLVRY ONLY - INSIDE DLVRY NOT AUTHORIZED",
  "D-CUSTOM CLEARANCE FEE - DELIVERY",
  "D-DO NOT CALL APPOINTMENT NOT REQUIRED",
  "D-GROCERY WAREHOUSE DELIVERY",
  "D-INSIDE DELIVERY REQUIRED",
  "D-LIFT GATE DELIVERY REQUIRED",
  "D-LIMITED ACCESS-CONSTRUCTION SITE-DEL",
  "D-LUMPER REQUIRED",
  "D-PACKING LIST ATTACHED",
  "D-PIECES MUST BE VERIFIED AT TIME OF DELIVERY",
  "D-REDELIVERY",
  "D-RESIDENTIAL DELIVERY",
  "D-SORT & SEG - DELIVERY",
  "D-WILL CALL",
];

export const bothAccessorialOptions = [
  "B-BLIND SHIPMENT",
  "B-I ENVELOPE",
  "B-8125 ATTACHED",
  "B-CERTIFIED CLASS CORRECTION",
  "B-CERTIFIED WEIGHT CORRECTION",
  "B-CGMAT",
  "B-DAYLIGHT PROTECT COVERAGE",
  "B-DEADHEAD",
  "B-DO NOT BREAK DOWN PALLET",
  "B-DO NOT DOUBLE STACK",
  "B-DO NOT DOUBLE STACK/DO NOT BREAK DOWN PALLET",
  "B-DO NOT STAND ON END",
  "B-DO NOT TOP LOAD",
  "B-EXCESS VALUE CHARGE",
  "B-FOR CARRIER CONV ONLY",
  "B-FRAGILE - HANDLE WITH CARE",
  "B-FREE ASTRAY",
  "B-ITEM 1360 CUBIC CAPACITY MIN RATED AT CLASS 125",
  "B-ITEM 1375 LINEAR FOOT RULE RATED AT 20M CLASS 65",
  "B-LEAVE BUNDLES INTACT",
  "B-LINEHAUL RETURN TO SHIPPER",
  "B-LOAD BARS/TIE DOWNS",
  "B-LOCAL RETURN TO SHIPPER",
  "B-MUST LAY FLAT",
  "B-PALLET TRAVEL UPRIGHT - SEE ARROWS",
  "B-OVERLENGTH ARTICLE 08 FT BLT 12 FT - ITEM 1485 APPLIED",
  "B-OVERLENGTH ARTICLE 12 FT BLT 20 FT - ITEM 1485 APPLIED",
  "B-OVERLENGTH ARTICLE 20 FT OR GREATER - ITEM 1485 APPLIED",
  "B-PACKING LIST ATTACHED",
  "B-SOUTHWESTERN MOTOR FREIGHT",
  "B-SPLIT SHIPMENT",
  "B-TO COMPLETE SHORTAGE",
  "B-TOP LOAD ONLY",
  "B-TRADE SHOW / CONVENTION SHIPMENT",
];

export const accessorialServices = [
  "Overlength 8 Ft But Less Than 12 Ft",
  "Overlength 12 Ft But Less Than 20 Ft",
  "Overlength 20 Ft Or Greater",
  "Vendor Compliance Shipment",
];

export const pickupServices = [
  "Inside Pickup Required",
  "Lift Gate Pickup Required",
  "Limited Access Or Construction Pickup",
];

export const deliveryServices = [
  "Limited Access Or Construction Site Delivery",
  "Residential Delivery",
  "Delivery Appointment Required",
  "Lift Gate Delivery Required",
  "Inside Delivery Required",
];

export const probillOptions = [
  { name: "Standard", value: "standard" },
  { name: "Express", value: "express" },
  { name: "Premium", value: "premium" },
];

// NMFC (National Motor Freight Classification) codes
export const nmfcOptions = [
  "19390",
  "50400",
  "84170",
  "85530",
  "116030",
  "125580",
  "133300",
  "148030",
  "161140",
  "172470",
];

// NMFC Sub codes
export const subOptions = ["Sub 1", "Sub 2", "Sub 3", "Sub 4", "Sub 5"];

export const shippingInstructionOptions = [
  "Overlength 12 Ft But Less Than 20 Ft",
  "Inside Pickup Required",
  "Grocery Warehouse Delivery",
  "Lift Gate Pickup Required",
  "Residential Delivery",
  "Delivery Appointment Required",
  "Limited Access Or Construction Site Delivery",
  "Inside Delivery Required",
  "Vendor Compliance Shipment",
  "Overlength 20 Ft Or Greater",
];

export const templateOptions = [
  { name: "Quote #QT-2024-001", value: "QT-2024-001" },
  { name: "Quote #QT-2024-002", value: "QT-2024-002" },
  { name: "Quote #QT-2024-003", value: "QT-2024-003" },
  {
    name: "Pickup #PU-2024-001",
    value: "PU-2024-001",
  },
  {
    name: "Pickup #PU-2024-002",
    value: "PU-2024-002",
  },
  {
    name: "Pickup #PU-2024-003",
    value: "PU-2024-003",
  },
];

// Mock order data for pickup details
export const mockOrderEntryData = {
  collectionType: "prepaid" as const,
  callerAccountSearch: "ACC-12345",
  shipperAccountSearch: "ACC-12345",
  shipperAccount: "ACC-12345",
  consigneeAccount: "ACC-67890",
  callerAccount: "ACC-12345",
  billToAccount: "ACC-12345",
  shipperAccountName: "Acme Corporation",
  consigneeAccountName: "ABC Technologies Pvt. Ltd (Western Division)",
  callerAccountName: "Alice Johnson",
  billToAccountName: "ABC Technologies Pvt. Ltd (Western Division)",
  shipperAddress: "123 Main Street",
  shipperCity: "Toronto",
  shipperState: "ON",
  shipperZip: "M5V 3A8",
  shipperContactName: "Bob Smith",
  shipperContactPhone: "416-555-0100",
  shipperCountry: "CA",
  consigneeAddress: "456 West Ave",
  consigneeCity: "Vancouver",
  consigneeState: "BC",
  consigneeZip: "70682",
  consigneeCountry: "CA",
  consigneeContactName: "Carol White",
  consigneeContactPhone: "604-555-0200",
  callerAddress: "123 Main Street",
  callerCity: "Toronto",
  callerState: "ON",
  callerZip: "M5V 3A8",
  callerCountry: "CA",
  callerContactName: "Alice Johnson",
  callerContactPhone: "416-555-0123",
  billToAddress: "123 Main Street",
  billToCity: "Toronto",
  billToState: "ON",
  billToZip: "M5V 3A8",
  billToCountry: "CA",
  billToContactName: "Finance Dept",
  billToContactPhone: "416-555-0100",
  freightItems: [
    {
      id: "1",
      pieces: "",
      pieceType: "",
      description: "",
      nmfc: "",
      sub: "",
      class: undefined,
      weight: "",
      isPrimary: true,
      serviceLevel: "MXUS-LTL",
    },
  ],
  handlingUnits: [
    {
      id: "1",
      handlingUnit: "",
      quantity: "",
      length: null,
      width: null,
      height: null,
      doNotStack: false,
      items: [
        {
          id: "1-item-1",
          pieces: "",
          pieceType: "",
          description: "",
          nmfc: "",
          sub: "",
          class: undefined,
          weight: "",
          isPrimary: true,
        },
      ],
    },
  ],
  linearFeet: "4",
  additionalServices: {
    accessorial: [],
    pickup: [],
    delivery: [],
  },
  shippingInstructions: {
    selectedServices: [],
  },
  daylightProtect: {
    declareAmount: undefined,
    purchaseCoverage: false,
  },
  additionalInfo: {
    additionalFields: [],
  },
  shipments: [
    {
      collectionType: "prepaid" as const,
      consigneeAccount: "ACC-67890",
      consigneeAccountName: "ABC Technologies Pvt. Ltd (Western Division)",
      consigneeAddress: "456 West Ave",
      consigneeCity: "Vancouver",
      consigneeState: "BC",
      consigneeZip: "70682",
      consigneeCountry: "CA",
      consigneeContactName: "Carol White",
      consigneeContactPhone: "604-555-0200",
      billToAccount: "ACC-12345",
      billToAccountName: "ABC Technologies Pvt. Ltd (Western Division)",
      billToAddress: "123 Main Street",
      billToCity: "Toronto",
      billToState: "ON",
      billToZip: "M5V 3A8",
      billToCountry: "CA",
      billToContactName: "Finance Dept",
      billToContactPhone: "416-555-0100",
      handlingUnits: [
        {
          id: "1",
          handlingUnit: "Pallet",
          quantity: "2",
          length: 48,
          width: 40,
          height: 48,
          doNotStack: false,
          isPrimary: true,
          items: [
            {
              id: "1-item-1",
              pieces: "5",
              pieceType: "Carton",
              description: "Electronic Components",
              nmfc: "60900",
              sub: "1",
              class: 70,
              weight: "500",
              isPrimary: true,
            },
          ],
        },
      ],
      linearFeet: "4",
      serviceLevel: "LTL-Standard",
      specialShipmentTags: "",
      criticalUrgentCareAppointment: {
        deliveryDate: undefined,
        appointmentStartTime: undefined,
        appointmentEndTime: undefined,
        approvedBy: "",
      },
      customsBrokerName: "",
      freightForwarder: {
        company: "",
        phone: "",
        referenceNumber: "",
        contactName: "",
        email: "",
        address: "",
        website: "",
      },
      additionalServices: {
        accessorial: [],
        pickup: [],
        delivery: [],
      },
      shippingInstructions: {
        selectedServices: [],
      },
      daylightProtect: {
        declareAmount: undefined,
        purchaseCoverage: false,
      },
      additionalInfo: {
        driverNotes: "",
        bolNotes: "",
        additionalFields: [],
      },
    },
  ],
};

// Additional mock data for pickup details
export const mockPickupMetadata = {
  pickupNumber: "PU-234567",
  pickupStatus: "PICKUP CREATED",
  quoteNumber: "QT-2024-001",
  quoteDate: "03/13/2026",
  pickupType: "Standard Pickup",
  pickupDateTime: "Fri, 3/20/2026 12:00 AM - 2:00 AM (PT)",
  accountExecutive: "Carlos Mendez",
  createdBy: "Carlos Mendez",
  pickupSteps: [
    {
      label: "Pickup Created",
      date: "Fri, 03-13-2026",
    },
    {
      label: "Driver Assigned",
      date: "Est. Sat, 03-14-2026",
    },
    {
      label: "Driver On the Way",
      date: "Est. Sat, 03-14-2026",
    },
    {
      label: "Picked Up",
      date: "Est. Sat, 03-14-2026",
    },
  ],
};

// Additional mock data for order summary
export const mockSummaryMetadata = {
  quoteNumber: "QT-2024-001",
  quoteDate: "03/13/2026",
  pickupType: "Standard Pickup",
  pickupDateTime: "Fri, 3/20/2026 12:00 AM - 2:00 AM (PT)",
  accountExecutive: "Carlos Mendez",
  createdBy: "Carlos Mendez",
  pickupStatus: "SCHEDULED",
};

export const originServiceCentre = {
  label: "Origin Service Centre",
  name: "Los Angeles Distribution Center",
  code: "LAX-01",
  address: "1500 Harbor Blvd, Long Beach, CA 90012",
  phone: "+1(213)-555-5000",
  email: "losangeles@xyz.com",
};

export const mockDisplayFallbacks = {
  accessorialList: [
    "Overlength 12 Ft But Less Than 20 Ft",
    "Inside Pickup Required",
    "Grocery Warehouse Delivery",
  ],
  driverNotes:
    "Dock #4 – Call 30 minutes before arrival. Forklift available on site.",
  bolNotes:
    "Freight shrink-wrapped and labeled by pallet. All pallets staged near shipping dock.",
  daylightAmount: "$5,000",
  traceNumber: "PO Number: 4578230041",
  huDescription: "Item",
  huNmfc: "19390",
  huSub: "Sub 1",
  huClass: 85,
  huWeight: 1000,
  huLength: 40,
  huWidth: 30,
  huHeight: 48,
};

export const mockPickupCallerShipperSummary = {
  callerAccountLine: "Acme Logistics Inc. (AC3678)",
  callerAddressStreet: "1200 S Grand Ave",
  callerAddressCity: "Los Angeles",
  callerAddressState: "CA",
  callerAddressZip: "90003",
  callerAddressCountry: "USA",
  callerContactName: "John Smith",
  callerContactPhone: "+1(213)-833-9012",
  shipperAccountLine: "XYZ Pvt. ltd. (AB1234)",
  shipperAddressStreet: "234 Figueroa St",
  shipperAddressCity: "Los Angeles",
  shipperAddressState: "CA",
  shipperAddressZip: "90001",
  shipperAddressCountry: "USA",
  shipperContactName: "Jane Doe",
  shipperContactPhone: "+1(213)-933-7332",
};

export const mockExpandedFreightPartyDisplay = {
  consigneeName: "Midwest Distribution LLC. (200892)",
  consigneeStatusChip: "ACTIVE",
  billToName: "XYZ Distribution LLC. (200892)",
  billToStatusChip: "CREDIT APPROVED",
  addressStreet: "4820 E Broadway Blvd",
  addressCity: "Tucson",
  addressState: "AZ",
  addressZip: "85711",
};

// Carrier/Company data
export const carrierOptions = [
  {
    id: 1,
    name: "Midwest Transport LLC",
    code: "AH7181",
    status: "ACTIVE",
    creditStatus: "CREDIT HOLD",
    address: "315 Main Ave",
    city: "Fargo",
    state: "ND",
    zipcode: "58001",
    country: "USA",
    contact: {
      name: "Emily Davis",
      phone: "+1(701)-555-0123",
      email: "edavis@midwest.com",
    },
    originServiceCenter: {
      name: "Fargo Distribution Center",
      code: "LAX-01",
      address: "1500 Harbor Blvd, Long Beach, CA 90012",
      phone: "+1(213)-555-5000",
      email: "fargo@xyz.com",
    },
    readyTime: "08:00",
    closeTime: "17:00",
  },
  {
    id: 2,
    name: "XYZ Pvt. ltd.",
    code: "AB1234",
    status: "ACTIVE",
    creditStatus: "CREDIT APPROVED",
    address: "234 metal way",
    city: "New York",
    state: "NY",
    zipcode: "10001",
    country: "USA",
    contact: {
      name: "Jane Doe",
      phone: "+1(312)-555-7283",
      email: "janed@xyz.com",
    },
    originServiceCenter: {
      name: "Los Angeles Distribution Center",
      code: "LAX-01",
      address: "1500 Harbor Blvd, Long Beach, CA 90012",
      phone: "+1(213)-555-5000",
      email: "janed@xyz.com",
    },
    readyTime: "07:00",
    closeTime: "16:00",
  },
  {
    id: 3,
    name: "Acme Logistics Inc.",
    code: "AC5678",
    status: "ACTIVE",
    creditStatus: "CREDIT APPROVED",
    address: "1200 S Grand Ave",
    city: "Los Angeles",
    state: "CA",
    zipcode: "90002",
    country: "USA",
    contact: {
      name: "John Smith",
      phone: "+1(213)-555-9012",
      email: "jsmith@acme.com",
    },
    originServiceCenter: {
      name: "Los Angeles Distribution Center",
      code: "LAX-02",
      address: "890 Commerce Way, Los Angeles, CA 90015",
      phone: "+1(213)-555-6000",
      email: "jsmith@acme.com",
    },
    readyTime: "06:00",
    closeTime: "18:00",
  },
  {
    id: 4,
    name: "Summit Supply Chain Co.",
    code: "AD9101",
    status: "ACTIVE",
    creditStatus: "CREDIT APPROVED",
    address: "430 Wilshire Blvd",
    city: "New York",
    state: "NY",
    zipcode: "10002",
    country: "USA",
    contact: {
      name: "Sarah Johnson",
      phone: "+1(213)-555-3456",
      email: "sjohnson@summit.com",
    },
    originServiceCenter: {
      name: "Wilshire Distribution Hub",
      code: "LAX-03",
      address: "500 Wilshire Blvd, Los Angeles, CA 90006",
      phone: "+1(213)-555-7000",
      email: "sjohnson@summit.com",
    },
    readyTime: "09:00",
    closeTime: "19:00",
  },
  {
    id: 5,
    name: "Apex Freight Solutions",
    code: "AE1121",
    status: "INACTIVE",
    creditStatus: "CREDIT HOLD",
    address: "789 Harbor Way",
    city: "Los Angeles",
    state: "CA",
    zipcode: "90012",
    country: "USA",
    contact: {
      name: "Mike Chen",
      phone: "+1(213)-555-7890",
      email: "mchen@apex.com",
    },
    originServiceCenter: {
      name: "Harbor Freight Center",
      code: "LAX-04",
      address: "800 Harbor Way, Los Angeles, CA 90013",
      phone: "+1(213)-555-8000",
      email: "mchen@apex.com",
    },
    readyTime: "05:00",
    closeTime: "15:00",
  },
  {
    id: 6,
    name: "Pacific Cargo Systems",
    code: "AG5161",
    status: "ACTIVE",
    creditStatus: "CREDIT APPROVED",
    address: "550 Temple St",
    city: "Los Angeles",
    state: "CA",
    zipcode: "90008",
    country: "USA",
    contact: {
      name: "David Lee",
      phone: "+1(213)-555-6789",
      email: "dlee@pacargo.com",
    },
    originServiceCenter: {
      name: "Temple Street Depot",
      code: "LAX-05",
      address: "600 Temple St, Los Angeles, CA 90009",
      phone: "+1(213)-555-9000",
      email: "dlee@pacargo.com",
    },
    readyTime: "10:00",
    closeTime: "20:00",
  },
  {
    id: 7,
    name: "Monterrey Distribución S.A. de C.V.",
    code: "MX2001",
    status: "ACTIVE",
    creditStatus: "CREDIT APPROVED",
    address: "Av. Constitución 1500, Centro",
    city: "Monterrey",
    state: "NL",
    zipcode: "64000",
    country: "Mexico",
    contact: {
      name: "Carlos Mendoza",
      phone: "+52(81)-8345-6700",
      email: "cmendoza@monterreydist.mx",
    },
    originServiceCenter: {
      name: "Monterrey Centro Logístico",
      code: "MTY-01",
      address: "Av. Constitución 1600, Centro, Monterrey, NL 64001",
      phone: "+52(81)-8345-6800",
      email: "cmendoza@monterreydist.mx",
    },
    readyTime: "08:30",
    closeTime: "17:30",
  },
  {
    id: 8,
    name: "Maple Leaf Distribution Ltd.",
    code: "CA3001",
    status: "ACTIVE",
    creditStatus: "CREDIT APPROVED",
    address: "100 King St W, Suite 4700",
    city: "Toronto",
    state: "ON",
    zipcode: "M5V 3L9",
    country: "Canada",
    contact: {
      name: "Aiden Clarke",
      phone: "+1(416)-555-8800",
      email: "aclarke@mapleleafdist.ca",
    },
    originServiceCenter: {
      name: "Toronto Logistics Hub",
      code: "YYZ-01",
      address: "200 King St W, Toronto, ON M5V 3M1",
      phone: "+1(416)-555-9900",
      email: "aclarke@mapleleafdist.ca",
    },
    readyTime: "07:00",
    closeTime: "16:00",
  },
];

// ZIP Code Mock Data
export const zipCodeMockData = {
  // ZIP codes with limited service (pickup available on specific days only)
  limitedServiceZips: [
    { zip: "90001", days: "Monday / Wednesday / Friday" },
    { zip: "90002", days: "Tuesday / Thursday / Saturday" },
    { zip: "10001", days: "Monday / Wednesday / Friday" },
    { zip: "10002", days: "Tuesday / Thursday" },
  ],

  // ZIP codes not serviceable by Daylight
  notServiceableZips: ["66777", "99999", "00000"],
};

// Transit time mock data - matches API response format
export const transitTimeMockData = [
  // Same zipcode (same location)
  { originZipcode: "90003", destinationZipcode: "90003", transitTime: 1 },
  { originZipcode: "58001", destinationZipcode: "58001", transitTime: 1 },
  { originZipcode: "10001", destinationZipcode: "10001", transitTime: 1 },
  { originZipcode: "90002", destinationZipcode: "90002", transitTime: 1 },
  { originZipcode: "10002", destinationZipcode: "10002", transitTime: 1 },
  { originZipcode: "90012", destinationZipcode: "90012", transitTime: 1 },
  { originZipcode: "90008", destinationZipcode: "90008", transitTime: 1 },
  { originZipcode: "64000", destinationZipcode: "64000", transitTime: 1 },
  { originZipcode: "M5V 3L9", destinationZipcode: "M5V 3L9", transitTime: 1 },

  // North Dakota (58001) to all locations
  { originZipcode: "58001", destinationZipcode: "10001", transitTime: 3 },
  { originZipcode: "58001", destinationZipcode: "10002", transitTime: 3 },
  { originZipcode: "58001", destinationZipcode: "90002", transitTime: 3 },
  { originZipcode: "58001", destinationZipcode: "90003", transitTime: 3 },
  { originZipcode: "58001", destinationZipcode: "90008", transitTime: 3 },
  { originZipcode: "58001", destinationZipcode: "90012", transitTime: 3 },
  { originZipcode: "58001", destinationZipcode: "64000", transitTime: 4 },
  { originZipcode: "58001", destinationZipcode: "M5V 3L9", transitTime: 3 },

  // New York 10001 to all locations
  { originZipcode: "10001", destinationZipcode: "58001", transitTime: 3 },
  { originZipcode: "10001", destinationZipcode: "10002", transitTime: 1 },
  { originZipcode: "10001", destinationZipcode: "90002", transitTime: 4 },
  { originZipcode: "10001", destinationZipcode: "90003", transitTime: 4 },
  { originZipcode: "10001", destinationZipcode: "90008", transitTime: 4 },
  { originZipcode: "10001", destinationZipcode: "90012", transitTime: 4 },
  { originZipcode: "10001", destinationZipcode: "64000", transitTime: 5 },
  { originZipcode: "10001", destinationZipcode: "M5V 3L9", transitTime: 2 },

  // New York 10002 to all locations
  { originZipcode: "10002", destinationZipcode: "58001", transitTime: 3 },
  { originZipcode: "10002", destinationZipcode: "10001", transitTime: 1 },
  { originZipcode: "10002", destinationZipcode: "90002", transitTime: 4 },
  { originZipcode: "10002", destinationZipcode: "90003", transitTime: 4 },
  { originZipcode: "10002", destinationZipcode: "90008", transitTime: 4 },
  { originZipcode: "10002", destinationZipcode: "90012", transitTime: 4 },
  { originZipcode: "10002", destinationZipcode: "64000", transitTime: 5 },
  { originZipcode: "10002", destinationZipcode: "M5V 3L9", transitTime: 2 },

  // California 90002 to all locations
  { originZipcode: "90002", destinationZipcode: "58001", transitTime: 3 },
  { originZipcode: "90002", destinationZipcode: "10001", transitTime: 4 },
  { originZipcode: "90002", destinationZipcode: "10002", transitTime: 4 },
  { originZipcode: "90002", destinationZipcode: "90003", transitTime: 1 },
  { originZipcode: "90002", destinationZipcode: "90008", transitTime: 1 },
  { originZipcode: "90002", destinationZipcode: "90012", transitTime: 1 },
  { originZipcode: "90002", destinationZipcode: "64000", transitTime: 4 },
  { originZipcode: "90002", destinationZipcode: "M5V 3L9", transitTime: 4 },

  // California 90003 to all locations
  { originZipcode: "90003", destinationZipcode: "58001", transitTime: 3 },
  { originZipcode: "90003", destinationZipcode: "10001", transitTime: 4 },
  { originZipcode: "90003", destinationZipcode: "10002", transitTime: 4 },
  { originZipcode: "90003", destinationZipcode: "90002", transitTime: 1 },
  { originZipcode: "90003", destinationZipcode: "90008", transitTime: 1 },
  { originZipcode: "90003", destinationZipcode: "90012", transitTime: 1 },
  { originZipcode: "90003", destinationZipcode: "64000", transitTime: 4 },
  { originZipcode: "90003", destinationZipcode: "M5V 3L9", transitTime: 4 },

  // California 90008 to all locations
  { originZipcode: "90008", destinationZipcode: "58001", transitTime: 3 },
  { originZipcode: "90008", destinationZipcode: "10001", transitTime: 4 },
  { originZipcode: "90008", destinationZipcode: "10002", transitTime: 4 },
  { originZipcode: "90008", destinationZipcode: "90002", transitTime: 1 },
  { originZipcode: "90008", destinationZipcode: "90003", transitTime: 1 },
  { originZipcode: "90008", destinationZipcode: "90012", transitTime: 1 },
  { originZipcode: "90008", destinationZipcode: "64000", transitTime: 4 },
  { originZipcode: "90008", destinationZipcode: "M5V 3L9", transitTime: 4 },

  // California 90012 to all locations
  { originZipcode: "90012", destinationZipcode: "58001", transitTime: 3 },
  { originZipcode: "90012", destinationZipcode: "10001", transitTime: 4 },
  { originZipcode: "90012", destinationZipcode: "10002", transitTime: 4 },
  { originZipcode: "90012", destinationZipcode: "90002", transitTime: 1 },
  { originZipcode: "90012", destinationZipcode: "90003", transitTime: 1 },
  { originZipcode: "90012", destinationZipcode: "90008", transitTime: 1 },
  { originZipcode: "90012", destinationZipcode: "64000", transitTime: 4 },
  { originZipcode: "90012", destinationZipcode: "M5V 3L9", transitTime: 4 },

  // Mexico 64000 to all locations
  { originZipcode: "64000", destinationZipcode: "58001", transitTime: 4 },
  { originZipcode: "64000", destinationZipcode: "10001", transitTime: 5 },
  { originZipcode: "64000", destinationZipcode: "10002", transitTime: 5 },
  { originZipcode: "64000", destinationZipcode: "90002", transitTime: 4 },
  { originZipcode: "64000", destinationZipcode: "90003", transitTime: 4 },
  { originZipcode: "64000", destinationZipcode: "90008", transitTime: 4 },
  { originZipcode: "64000", destinationZipcode: "90012", transitTime: 4 },
  { originZipcode: "64000", destinationZipcode: "M5V 3L9", transitTime: 5 },

  // Canada M5V 3L9 to all locations
  { originZipcode: "M5V 3L9", destinationZipcode: "58001", transitTime: 3 },
  { originZipcode: "M5V 3L9", destinationZipcode: "10001", transitTime: 2 },
  { originZipcode: "M5V 3L9", destinationZipcode: "10002", transitTime: 2 },
  { originZipcode: "M5V 3L9", destinationZipcode: "90002", transitTime: 4 },
  { originZipcode: "M5V 3L9", destinationZipcode: "90003", transitTime: 4 },
  { originZipcode: "M5V 3L9", destinationZipcode: "90008", transitTime: 4 },
  { originZipcode: "M5V 3L9", destinationZipcode: "90012", transitTime: 4 },
  { originZipcode: "M5V 3L9", destinationZipcode: "64000", transitTime: 5 },
];

// Default origin service center for new accounts
export const getDefaultOriginServiceCenter = () =>
  carrierOptions[0].originServiceCenter;
